<h2>{{ paymentOptions?.title }}</h2>
<mat-divider style="margin-bottom: 30px"></mat-divider>

<div *ngIf="isFetchingData && !errorMessage" fxLayout="column" fxLayoutAlign="center center">
  <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
  <p>Loading...</p>
</div>
<div *ngIf="errorMessage" class="mb-1">
  {{ errorMessage }}
</div>

<div [formGroup]="form" [ngClass]="isFetchingData || paymentOptions?.isCheckoutAvailable === false ? 'd-none' : ''">
  <!--header stuff-->
  <div [innerHtml]="paymentOptions?.description | safeHtml"></div>
  <div class="mb-1" fxLayout="column">
    <mat-form-field appearance="outline" *ngIf="paymentOptions?.options?.length > 1">
      <mat-label for="nameOnCard">
        Payment Type <span class="required" aria-label="This is a required field">*</span>
      </mat-label>
      <mat-select [(value)]="selectedPaymentOption">
        <mat-option *ngFor="let option of paymentOptions.options" [value]="option">
          {{ option.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <table mat-table *ngIf="selectedPaymentOption" [dataSource]="selectedPaymentOption.lineItems">
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>Fee</th>
        <th mat-footer-cell *matFooterCellDef>Total</th>
        <td mat-cell *matCellDef="let element" class="custom-fields-name">{{ element.label }}</td>
      </ng-container>
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let element" class="custom-fields-name">{{ element.amount | currency: 'USD' }}</td>
        <th mat-footer-cell *matFooterCellDef>{{ selectedPaymentOption.totalAmount | currency: 'USD' }}</th>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
  </div>

  <img
    class="ml-1 mb-1"
    *ngIf="selectedPaymentOption?.paymentType !== 'Check'"
    alt="powered by stripe"
    src="/assets/images/powered-by-stripe.png"
  />

  <!--CARD STUFF-->
  <div class="two-columns" fxLayout.xs="column" [ngClass]="{ 'd-none': selectedPaymentOption?.paymentType !== 'Card' }">
    <!--
We do some hacks below to get Stripe Elements to play nicely with Angular Material. The actual input controlled by Angular Material is hidden.
It's just there to satisfy mat-form-field's requirements. The actual inputs come from Stripe Elements.
-->
    <div fxLayout="column">
      <label for="nameOnCard">Name on Card <span class="required" aria-label="This is a required field">*</span></label>
      <mat-form-field appearance="outline">
        <input id="nameOnCard" matInput formControlName="nameOnCard" required placeholder="Name on Card" />
        <mat-error *ngIf="form.controls.nameOnCard.hasError('required')">Name on Card is required</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="column">
      <label for="card-expiry"
        >Expiration Date <span class="required" aria-label="This is a required field">*</span></label
      >
      <mat-form-field appearance="outline">
        <div id="card-expiry"></div>
        <input formControlName="hiddenField" [errorStateMatcher]="expiryError" matInput class="d-none" />
      </mat-form-field>
    </div>
    <div fxLayout="column">
      <label for="card-number">Card Number <span class="required" aria-label="This is a required field">*</span></label>
      <mat-form-field appearance="outline">
        <div id="card-number"></div>
        <input formControlName="hiddenField" [errorStateMatcher]="cardNumberError" matInput class="d-none" />
      </mat-form-field>
    </div>
    <div fxLayout="column">
      <label for="card-cvc">Security Code <span class="required" aria-label="This is a required field">*</span></label>
      <mat-form-field appearance="outline">
        <div id="card-cvc"></div>
        <input formControlName="hiddenField" [errorStateMatcher]="cvcError" matInput class="d-none" />
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="selectedPaymentOption?.paymentType === 'Card'" class="mb-1">
    <mat-checkbox *ngIf="addressFromApplication" color="primary" formControlName="isUsingAddressProvided"
      >Use the address I provided</mat-checkbox
    >
    <h2>Billing Address</h2>
    <read-only-address
      *ngIf="addressFromApplication && form.value.isUsingAddressProvided"
      [address]="addressFromApplication"
      [hideStatus]="true"
    >
      <div class="semi-bold"></div>
    </read-only-address>

    <address-editor *ngIf="!form.value.isUsingAddressProvided" [address]="manualMailingAddress"></address-editor>
  </div>
  <!--ACH Stuff-->
  <div class="mb-1" *ngIf="selectedPaymentOption?.paymentType === 'Ach'">
    <div fxLayout="column">
      <label for="nameOnCard"
        >Name on Account <span class="required" aria-label="This is a required field">*</span></label
      >
      <mat-form-field appearance="outline">
        <input id="nameOnCard" matInput formControlName="nameOnAccount" required placeholder="Name on Account" />
      </mat-form-field>
    </div>

    <button mat-flat-button color="primary" (click)="connectACH()" type="button" *ngIf="!achPaymentMethod?.id">
      Search for your bank<mat-icon>launch</mat-icon>
    </button>
    <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="achPaymentMethod?.id">
      <div fxLayout="row">
        <mat-icon class="mr-medium">account_balance</mat-icon>{{ achPaymentMethod.us_bank_account.bank_name }}
        {{ achPaymentMethod.us_bank_account.account_type }} (XXX{{ achPaymentMethod.us_bank_account.last4 }})
      </div>
      <button mat-icon-button type="button" (click)="removeACH()"><mat-icon>cancel</mat-icon></button>
    </div>
  </div>
  <div
    *ngIf="selectedPaymentOption?.paymentType === 'Check'"
    class="mb-1"
    fxLayout="column"
    [innerHtml]="paymentOptions?.checkInstructions | safeHtml"
  ></div>
</div>

<div class="mb-1" *ngIf="paymentOptions?.isCheckoutAvailable === false">
  The total amount due is $0. Click submit to finish your application.
</div>
